import React, { forwardRef, useEffect } from 'react';
import HelpCard from '../HelpCard';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from '../../../redux/actions/action-creator';
import { useLocation, useNavigate } from 'react-router-dom';
import { Line } from 'react-bootstrap-icons';

const LedgerVoucherHelp = forwardRef((props, ref) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const modal_state = useSelector(state => state.common.modal_state)

    const fields = [
        {
            id: "1",
            name: props.state_configure?.formate_of_report === "Detailed" ? "Condensed" : "Detailed",
            shortcutKey: "F1",
            underline: "single",
            state: () => props.toggleDetailedCondensed && props.toggleDetailedCondensed()
        },
        { id: "2", name: "Period", shortcutKey: "F2", state: () => dispatch(openModal('period')) },
        { id: "3", name: "Ledger", shortcutKey: "F4", state: () => navigate('/ledgerbook') },
        { id: "7", name: "Change View", shortcutKey: "H", underline: "double", state: () => dispatch(openModal('changeViewLedgerVoucher')) },
        { id: "4", name: "Export", shortcutKey: "E", state: () => dispatch(openModal('export')) },
        { id: "5", name: "Print", shortcutKey: "P", state: () => dispatch(openModal('print')) },
        { id: "6", name: "Configure", shortcutKey: "F12", state: () => dispatch(openModal('configure')) },
    ]
    return (
        <>
            {
                modal_state.period || modal_state.export || modal_state.print || modal_state.configure || modal_state.otherLedger || location.pathname.includes('ledgerbook') || modal_state.delete || modal_state.changeViewLedgerVoucher ? null : (
                    <>

                        {
                            fields.slice(0, 4).map((item, index) => {
                                return (
                                    <HelpCard key={item.id} fields={item} />
                                )
                            })
                        }
                        <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                            {
                                fields.slice(4).map((item, index) => {
                                    return (
                                        <HelpCard key={item.id} fields={item} />
                                    )
                                })
                            }

                        </div>
                    </>
                )
            }

        </>
    )
})

export default LedgerVoucherHelp;